






















































































































































































































import { Component, Ref, Vue, Watch } from "vue-property-decorator";
import SoapDokterSvc from "@/services/SoapDokter";
import SoapPerawatSvc from "@/services/SoapPerawat";
import { storePasien } from "@/store/modules/pasien";
import { userModule } from "@/store/modules/user";
import ModalBatalSoap from "@/components/modal/ModalBatalSoap.vue";
import { appModule } from "@/store/modules/app";
import NewSoapStore from "@/store/modules/NewSoapStore";
import moment from "moment";
import AsesmenGadarMedisStore from "@/store/modules/AsesmenAwalGadar/AsesmenGadarMedisStore";
import AsesmenSurveyPrimerGadarStore from "@/store/modules/AsesmenAwalGadar/AsesmenSurveyPrimerGadarStore";
import AsesmenGadarKeperawatanStore from "@/store/modules/AsesmenAwalGadar/AsesmenGadarKeperawatanStore";
import { isEmpty } from "lodash";

@Component({
  components: {
    ModalBatalSoap
  }
})
export default class SoapPage extends Vue {
  @Ref() examinedAtPicker: HTMLElement;

  isFormValid = true;
  validasi = [v => !!v || "*Kolom ini harus diisi"];

  id = null;
  subjective: string = null;
  objective: string = null;
  assesment: string = null;
  plan: string = null;
  examinedAt: string | Date = null;

  @Watch("examinedAt")
  changedExaminedAt(val) {
    if (!val) {
      this.examinedAtPicker["clearHandler"]();
    }
  }

  removing = false;
  saving = false;

  showBatal = false;

  timePickerProps = { format: "24hr", scrollable: true };
  datePickerProps = { locale: "id", max: moment().format("YYYY-MM-DD") };
  dateTimeFieldProps = { outlined: true, dense: true, "hide-details": "auto" };

  get showGenerateBtn() {
    return (
      !isEmpty(this.asesmenMedisGadar) &&
      userModule.isMedis &&
      this.soapDokterList?.length < 1
    );
  }

  get soapList() {
    return NewSoapStore.soapList;
  }

  get soapDokterList() {
    return NewSoapStore.soapDokterList;
  }

  get canEditSoap() {
    return this.canMakeSoap && this.id;
  }

  get canMakeSoap() {
    return this.stateUser.is_nakes;
  }

  get isDokter() {
    return ["Dokter", "Psikolog"].includes(this.stateUser.profesi);
  }

  get isPerawat() {
    return ["Perawat", "Bidan"].includes(this.stateUser.profesi);
  }

  get registerId(): number {
    return storePasien.identitasPasien?.register?.no
      ? parseInt(storePasien.identitasPasien.register.no)
      : null;
  }

  get pasienRm(): number {
    return storePasien.identitasPasien?.rm
      ? parseInt(storePasien.identitasPasien.rm)
      : null;
  }

  get loadingList(): boolean {
    return NewSoapStore.loadingList;
  }

  get stateUser() {
    return userModule.user;
  }

  get formatedExaminedAt() {
    return this.examinedAt
      ? moment(this.examinedAt).format("YYYY-MM-DD HH:mm:ss")
      : null;
  }

  get input() {
    return {
      register_id: this.registerId,
      pasien_cm: this.pasienRm,
      unit_id: this.stateUser.unit_id,
      subjective: this.subjective,
      objective: this.objective,
      assesment: this.assesment,
      plan: this.plan,
      examined_at: this.formatedExaminedAt
    };
  }

  mounted() {
    NewSoapStore.getByRegister(this.registerId);

    this.clearInput();
  }

  async save() {
    let SoapService = null;

    if (this.isDokter) {
      SoapService = SoapDokterSvc;
    } else if (this.canMakeSoap) {
      SoapService = SoapPerawatSvc;
    } else {
      appModule.sendErrorAlert(
        "Tidak dapat membuat SOAP selain pengguna yang terdaftar sebagai NaKes"
      );
      return false;
    }

    if (!this.saving) {
      this.saving = true;

      try {
        const resp = this.id
          ? await SoapService.update(this.id, this.input)
          : await SoapService.create(this.input);

        if (!this.id) {
          this.id = resp["id"];
        }

        this.getByRegister();
      } catch (err) {
        this.saving = false;
      }

      this.saving = false;
    }
  }

  async getByRegister() {
    NewSoapStore.getByRegister(this.registerId);
  }

  async remove(alasan = null) {
    let SoapService = null;

    if (this.isDokter) {
      SoapService = SoapDokterSvc;
    } else if (this.isPerawat) {
      SoapService = SoapPerawatSvc;
    } else {
      appModule.sendErrorAlert(
        "Tidak dapat menghapus SOAP selain pengguna yang terdaftar sebagai NaKes"
      );
      return false;
    }

    if (!this.removing) {
      this.removing = true;

      try {
        await SoapService.destroy(this.id, alasan?.alasan);

        await this.getByRegister();

        this.clearInput();
      } catch (err) {
        //
      } finally {
        this.removing = false;
      }
    }
  }

  removeHandler() {
    const q = confirm("Menghapus SOAP ini?");

    if (q) {
      // this.remove();
      this.showBatal = true;
    }
  }

  editSoapItem(item) {
    if (item.user.id == this.stateUser.id) {
      this.id = item.id;
      this.subjective = item.s;
      this.objective = item.o;
      this.assesment = item.a;
      this.plan = item.p;
      this.examinedAt = item.examined_at ? new Date(item.examined_at) : null;
    } else {
      appModule.sendErrorAlert(
        "Tidak dapat mengubah SOAP yang dituliskan orang lain!"
      );
    }
  }

  makeNew() {
    this.clearInput();
  }

  clearInput() {
    this.id = null;
    this.subjective = null;
    this.objective = null;
    this.assesment = null;
    this.plan = null;
    this.examinedAt = null;
  }

  handleGenerateSoap() {
    if (this.subjective || this.objective || this.assesment || this.plan) {
      alert("Tidak bisa generate bila kolom isian sudah terisi!");
    } else {
      this.generateFromAsesmenAwal();
    }
  }

  get asesmenMedisGadar() {
    return AsesmenGadarMedisStore.asesmen;
  }

  get asesmenPerawatGadar() {
    return AsesmenGadarKeperawatanStore.asesmen;
  }

  generateFromAsesmenAwal() {
    const anamnesis = this.asesmenMedisGadar?.content.anamnesis,
      keluhan = anamnesis?.keluhanUtama,
      riwSekarang = anamnesis?.riwayatPenyakitSekarang,
      riwDulu = anamnesis?.riwayatPenyakitDahulu;

    const ttv = AsesmenSurveyPrimerGadarStore.asesmen?.content?.tanda_vital,
      tensi = ttv?.tensi
        ? `TD: ${ttv.tensi.sistole}/${ttv.tensi.diastole} mmHg`
        : "",
      nadi = ttv?.nadi ? `HR: ${ttv.nadi} x/menit` : "",
      nafas = ttv?.nafas ? `RR: ${ttv.nafas} x/menit` : "",
      suhu = ttv?.suhu ? `SB: ${ttv.suhu} *C` : "",
      saturasi = ttv?.saturasi ? `SpO2: ${ttv.saturasi}%` : "",
      ttvText = [tensi, nadi, nafas, suhu, saturasi]
        .filter(item => item !== "")
        .join("; ")
        .trim();

    const kepala = this.asesmenMedisGadar?.content.fisik?.kepala
        ? `Kepala: ${this.asesmenMedisGadar.content.fisik.kepala}`
        : "",
      leher = this.asesmenMedisGadar?.content.fisik?.leher
        ? `Leher: ${this.asesmenMedisGadar.content.fisik.leher}`
        : "",
      dada = this.asesmenMedisGadar?.content.fisik?.dada
        ? `Dada: ${this.asesmenMedisGadar.content.fisik.dada}`
        : "",
      paru = this.asesmenMedisGadar?.content.fisik?.paru
        ? `Paru: ${this.asesmenMedisGadar.content.fisik.paru}`
        : "",
      jantung = this.asesmenMedisGadar?.content.fisik?.jantung
        ? `Jantung: ${this.asesmenMedisGadar.content.fisik.jantung}`
        : "",
      perut = this.asesmenMedisGadar?.content.fisik?.perut
        ? `Perut: ${this.asesmenMedisGadar.content.fisik.perut}`
        : "",
      genital = this.asesmenMedisGadar?.content.fisik?.genital
        ? `Genital: ${this.asesmenMedisGadar.content.fisik.genital}`
        : "",
      ektrimitaAtas = this.asesmenMedisGadar?.content.fisik?.ektrimitaAtas
        ? `Ektrimita Atas: ${this.asesmenMedisGadar.content.fisik.ektrimitaAtas}`
        : "",
      ektrimitaBawah = this.asesmenMedisGadar?.content.fisik?.ektrimitaBawah
        ? `Ektrimita Bawah: ${this.asesmenMedisGadar.content.fisik.ektrimitaBawah}`
        : "",
      tubuhBelakang = this.asesmenMedisGadar?.content.fisik?.tubuhBelakang
        ? `Tubuh Belakang: ${this.asesmenMedisGadar.content.fisik.tubuhBelakang}`
        : "",
      pFisikText = [
        kepala,
        leher,
        dada,
        paru,
        jantung,
        perut,
        genital,
        ektrimitaAtas,
        ektrimitaBawah,
        tubuhBelakang
      ]
        .filter(item => item !== "")
        .join("; ");

    const pObgyn = this.asesmenPerawatGadar?.content?.riwayatObstetri,
      pOgbynText = [
        pObgyn?.tfu ? `TFU: ${pObgyn.tfu} cm` : "",
        pObgyn?.tbj ? `TBJ: ${pObgyn.tbj} gr` : "",
        pObgyn?.djj ? `DJJ: ${pObgyn.djj} x/mnt` : "",
        pObgyn?.lla ? `LLA: ${pObgyn.lla} cm` : "",
        pObgyn?.vt ? `VT: ${pObgyn.vt}` : "",
        pObgyn?.his ? `HIS: ${pObgyn.his}` : ""
      ]
        .filter(item => item !== "")
        .join("; ")
        .trim();

    const subj = [
        keluhan ? `Keluhan: ${keluhan}` : "",
        riwSekarang ? `Riwayat penyakit sekarang: ${riwSekarang}` : "",
        riwDulu ? `Riwayat penyakit dahulu: ${riwDulu}` : ""
      ]
        .filter(item => item !== "")
        .join("\r\n")
        .trim(),
      obj = [ttvText, pFisikText, pOgbynText]
        .filter(item => item !== "")
        .join("\r\n")
        .trim(),
      ases = this.asesmenMedisGadar?.content?.diagnosis?.kerja,
      plan = this.asesmenMedisGadar?.content?.terapi?.terapi;

    this.subjective = subj;
    this.objective = obj;
    this.assesment = ases;
    this.plan = plan;
  }

  formatDate(date) {
    return date ? moment(date).format("DD-MM-YYYY HH:mm") : null;
  }

  showEditButton(user) {
    return user.id == this.stateUser.id;
  }
}
